import { render, staticRenderFns } from "./comp_CheckoutStep-confirm.vue?vue&type=template&id=dcae9f7e&scoped=true&"
import script from "./comp_CheckoutStep-confirm.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutStep-confirm.vue?vue&type=script&lang=js&"
import style0 from "./comp_CheckoutStep-confirm.vue?vue&type=style&index=0&id=dcae9f7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcae9f7e",
  null
  
)

export default component.exports